module.exports = __webpack_public_path__ + "img/monitor-swiper-3.4028dcc6.png";